import React, { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import './long-description.css';
import { classNames } from '../../../utils/component-utils';
import { useIsComponentOverflowing } from '../../../hooks/overflow-hook';
interface ILongDescription {
    description: string;
}

const LongDescription = ({ description }: ILongDescription) => {
    const descriptionRef = useRef<HTMLParagraphElement>(null);
    const intl = useIntl();
    const [showLongDescription, setShowLongDescription] = useState(false);

    const isOverflowing = useIsComponentOverflowing(
        descriptionRef,
        description
    );

    return (
        <div>
            <p
                className={classNames({
                    'long-description': true,
                    'long-description--shortened': !showLongDescription,
                })}
                ref={descriptionRef}
                dangerouslySetInnerHTML={{ __html: description }}
            ></p>
            {(isOverflowing || showLongDescription) && (
                <a
                    onClick={() =>
                        setShowLongDescription(
                            (showLongDescription: boolean) =>
                                !showLongDescription
                        )
                    }
                >
                    {intl.formatMessage({
                        id: showLongDescription ? 'show_less' : 'show_more',
                        defaultMessage: showLongDescription
                            ? 'show_less'
                            : 'show more',
                    })}
                </a>
            )}
        </div>
    );
};

export default LongDescription;
